import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

/**
 * Plantilla de correo de comunicaciones (entidad EmailTemplate, id NUMÉRICO).
 * Es la que valida el checklist de activación del workflow — NO la plantilla de
 * marketing (UUID). El backend expone un Flux (array no paginado) sin campo `name`.
 */
export interface EmailTemplateResponse {
  id: number;
  purpose: string;
  locale: string;
  version: number;
  subject: string;
  bodyHtml?: string | null;
  bodyText?: string | null;
}

/**
 * Consume GET /api/admin/email-templates (endpoint admin, rol requerido).
 * Devuelve un ARRAY (no paginado) sin filtro de texto server-side → el buscador
 * filtra client-side por subject/purpose (patrón EntitySelect con filtrado local).
 */
@Injectable({ providedIn: 'root' })
export class WorkflowEmailTemplateApiService {
  private readonly url = `${environment.apiUrl}api/admin/email-templates`;

  constructor(private http: HttpClient) {}

  list(purpose?: string): Observable<EmailTemplateResponse[]> {
    let params = new HttpParams();
    if (purpose) params = params.set('purpose', purpose);
    return this.http.get<EmailTemplateResponse[]>(this.url, { params });
  }
}
